import { useLayoutEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { selectTranslations } from 'app/pages/App/slice/selectors';

interface useTitleSizeParams {
  title: string[];
  useTranslation?: boolean;
  padding?: number;
  textStyle?: string;
}

const useTitleSize = ({
  title,
  useTranslation = true,
  padding = 40,
  textStyle,
}: useTitleSizeParams) => {
  const [result, setResult] = useState<Record<string, number>>({});
  const translations = useSelector(selectTranslations);
  const ctx = useRef(document.createElement('canvas').getContext('2d')).current;

  if (ctx) {
    ctx!.font = textStyle ?? "600 14px 'Be Vietnam Pro'";
  }

  useLayoutEffect(() => {
    const titleSizes = title.reduce((result, t) => {
      const title = useTranslation ? translations?.[t] ?? '' : t;
      const metrics = ctx?.measureText(title);
      result[t] = Math.ceil(metrics?.width ?? 0) + padding;
      return result;
    }, {} as Record<string, number>);

    setResult(titleSizes);
  }, [translations, ctx, useTranslation, JSON.stringify(title), padding]);

  return result;
};

export default useTitleSize;
